var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',_vm._g(_vm._b({staticClass:"btn-create",attrs:{"icon":"plus","iconset":"fa"}},'btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm._f("trans")('Create')))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }